import { useFragmentFromStore } from '@smx-ui-model/hooks/use-fragment-from-store';
import { memo } from 'react';

interface EntitySelectOptionProps<T> {
    node: any;
    listFieldName?: (keyof T)[];
}

export const EntitySelectOption = <T,>({ node, listFieldName }: EntitySelectOptionProps<T>) => {
    // FIXME: any
    const dataEntity = useFragmentFromStore(node) as any;
    return listFieldName?.map((name) => dataEntity[name]).join(' ') || dataEntity['name'];
};

export default memo(EntitySelectOption);
